import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "Context/userAuthContext";
import _ from "lodash";

interface RequireOnboardingProps {
  children: JSX.Element;
}

export const RequireOnboarding: React.FC<RequireOnboardingProps> = ({
  children,
}) => {
  const { sellerProfile } = useSession();
  const location = useLocation();

  // If onboarding is not complete, redirect to home where the modal will open
  if (_.isEmpty(sellerProfile.username)) {
    return <Navigate to="/admin/home" state={{ from: location }} replace />;
  }

  return children;
};
